export default __webpack_public_path__ + "static/premium-face-unlock-hero-cd586e8ec6d5027039fcb24e471c7ec8.png";